import axios from 'axios';
const token = $('meta[name="csrf-token"]').attr('content');

axios.defaults.withCredentials = true;

$.ajaxSetup({
    // Enables cross domain requests
    crossDomain: true,

    // Helps in setting cookie
    xhrFields: {
        withCredentials: true
    },

    beforeSend: function (xhr, type) {
        // Set the CSRF Token in the header for security
        if (type.type !== "GET") {
            xhr.setRequestHeader('X-CSRF-Token', token);
        }
    }
});

